export const AUTH_ROLES = {
  parent: ['PARENT'],
  teen: ['TEEN'],
  onlyGuest: [],
  user: ['PARENT', 'TEEN'],
};
